import _ from "underscore";
import { XMLHttpRequestUploaderConfig } from "./chunks/xmlHttpRequestUploader";
import { IBlobReader, IChunkSizeProvider, IThumbnaiProvider, IUploaderConfig } from "./config";
import { isFinalStatus, SequentialTaskQueueProcessor, TaskQueueStatus } from "./tasks/taskProcessor";
import { IFileUploadManager, UploadTaskProvider } from "./uploadTaskProvider";

export { TaskResultStatus } from "./tasks/task";
export { TaskQueueStatus, TaskProcessingResult } from "./tasks/taskProcessor";
export { IFileUploadManager } from "./uploadTaskProvider";

export class TaskQueueStatusHelper {
  public static canRetry(status: TaskQueueStatus) {
    return status === TaskQueueStatus.Error;
  }
  public static isFinal(status: TaskQueueStatus) {
    return isFinalStatus(status);
  }
}

export interface IUploader {
  getUploads(): IFileUploadManager[];
  enqueueFiles(fileList: FileList, type: string, subtype: string, additionalMetadata: any): void;
  enqueueFile(file: File, type: string, subtype: string, additionalMetadata: any): void;
  subscribe(onChange: () => void): () => void;
}

export function createXmlHttpUploader(
    url: string,
    blobReader: IBlobReader,
    thumbnaiProvider: IThumbnaiProvider,
    chunkSizeProvider: IChunkSizeProvider,
    onCompletion?: (result: IUploadJob) => void): IUploader {

  return new Uploader(new XMLHttpRequestUploaderConfig(url, blobReader, thumbnaiProvider, chunkSizeProvider), onCompletion);
}

// export function createMockUploader(): IUploader{
//   return createUploader(new MockUploaderConfig());
// }

// tslint:disable-next-line: max-classes-per-file
class Uploader implements IUploader {
  public getUploads() {
    return _.map(this.processer.queues, u => (u as UploadTaskProvider).upload);
  }

  private processer: SequentialTaskQueueProcessor;
  constructor(private config: IUploaderConfig, private onUploadCompletion: (result: IUploadJob) => void = (x) => {}) {
    this.processer = new SequentialTaskQueueProcessor(() => this.emitChange());
  }

  public enqueueFiles(fileList: FileList, type: string, subtype: string, additionalMetadata: any): UploadTaskProvider[] {
    return _.map(fileList, f => this.createUploadManager(f, type, subtype, additionalMetadata));
  }

  public enqueueFile(file: File, type: string, subtype: string, additionalMetadata: any): UploadTaskProvider {
    return this.createUploadManager(file, type, subtype, additionalMetadata);
  }

  private createUploadManager(file: File, type: string, subtype: string, additionalMetadata: any) {
    const taskProvider = new UploadTaskProvider(file, type, subtype, additionalMetadata, this.config, this.processer, () => this.emitChange(), r => this.onUploadCompletion(r));
    this.processer.enqueue(taskProvider);
    return taskProvider;
  }

  private hooks: (() => void)[] = [];
  public subscribe(onChange: () => void): () => void {
    this.hooks.push(onChange);
    return () => this.hooks = _.filter(this.hooks, h => h !== onChange);
  }

  private emitChange() {
    _.each(this.hooks, h => h());
  }
}
